var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Soongjin Park
 * @contact sjpark@detech.co.kr
 * @date 2022-05-09
 * @brief 비동기 Http 함수
 *
 ********************************************************************/
import axios from "axios";
//
import * as HttpConf from "./HttpConf";
//
import * as CUTIL from "../../utils/commUtils";
import * as CONST from "../../utils/Const";
import * as FILEUTILS from "../../utils/file/fileUtil";
import * as UNIQUE from "../uniqueUtils";
function encodeUrlPath(url) {
    var pos = url.indexOf("?");
    if (pos < 0) {
        // not found
        pos = url.length;
    }
    var spath = url.substring(0, pos);
    var params = url.substring(pos + 1, url.length);
    var psp = spath.split("/");
    var path = "";
    for (var i = 0; i < psp.length; i++) {
        if (psp[i].length <= 0)
            continue;
        path = path + "/" + encodeURIComponent(psp[i]);
    }
    var sp = params.split("&");
    for (var i = 0; i < sp.length; i++) {
        if (sp[i].length <= 0)
            continue;
        if (i === 0) {
            path = path + "?";
        }
        else {
            path = path + "&";
        }
        var p = sp[i].indexOf("=");
        if (p < 0) {
            path = path + encodeURIComponent(sp[i]);
        }
        else {
            path = path + sp[i].substring(0, p) + "=" + encodeURIComponent(sp[i].substring(p + 1, sp[i].length));
        }
    }
    return path;
}
/**
 * @brief useAync hook : 비동기 HTTP API 호출 - Action 없이 작동
 * @param param0 httpMethod:<string>: GET|POST|PUT ..
 * @param param1 appPath:<string>: API App Path ..
 * @param param2 appQuery:<json>: API App params ..
 * @returns
 */
export function PromiseHttp({ httpMethod, appPath, appQuery, userToken, onUploadProgress }) {
    return __awaiter(this, void 0, void 0, function* () {
        return Http([], { httpMethod, appPath, appQuery, userToken, onUploadProgress });
    });
}
/**
 * @brief useAync hook : 비동기 HTTP API 호출 - Action에 의해 작동
 * @param param0 httpMethod:<string>: GET|POST|PUT ..
 * @param param1 appPath:<string>: API App Path ..
 * @param param2 appQuery:<json>: API App params ..
 * @returns
 */
export function Http(args, { httpMethod, appPath, appQuery, userToken, onUploadProgress }) {
    return __awaiter(this, void 0, void 0, function* () {
        let response;
        let httpResp = {
            status: 500,
            codeNum: CONST.API_999,
            data: "",
            body: "",
            errorList: [{ field: `cntError`, msg: CONST.ERROR_SERVER_MSG }],
        };
        let appMethod = httpMethod === "POST" ? "POST" : httpMethod === "PUT" ? "PUT" : httpMethod === "GET" ? "GET" : "DELETE";
        if (httpMethod == "POST") {
            appMethod = "POST";
        }
        else if (httpMethod == "POSTF") {
            appMethod = "POSTF";
        }
        else if (httpMethod == "PUT") {
            appMethod = "PUT";
        }
        else if (httpMethod == "GET") {
            appMethod = "GET";
        }
        else if (httpMethod == "GETF") {
            appMethod = "GETF";
        }
        else if (httpMethod == "DELETE") {
            appMethod = "DELETE";
        }
        else if (httpMethod == "DELETEDATA") {
            appMethod = "DELETEDATA";
        }
        else {
            return "Unknonw API Method!!!!";
        }
        appPath = encodeUrlPath(appPath);
        try {
            if (appMethod == "POST") {
                response = yield axios({
                    headers: { Authorization: userToken },
                    method: appMethod,
                    url: HttpConf.API_BASE + appPath,
                    data: appQuery,
                });
            }
            else if (appMethod == "POSTF") {
                response = yield axios({
                    headers: { Authorization: userToken, "Content-Type": "multipart/form-data" },
                    method: "POST",
                    url: HttpConf.API_BASE + appPath,
                    data: appQuery,
                    onUploadProgress(progressEvent) {
                        onUploadProgress(progressEvent);
                    },
                });
            }
            else if (appMethod == "PUT") {
                response = yield axios({
                    headers: { Authorization: userToken },
                    method: appMethod,
                    url: HttpConf.API_BASE + appPath,
                    data: appQuery,
                });
            }
            else if (appMethod == "DELETE") {
                response = yield axios({
                    headers: { Authorization: userToken },
                    method: appMethod,
                    url: HttpConf.API_BASE + appPath,
                    params: appQuery,
                });
            }
            else if (appMethod == "DELETEDATA") {
                response = yield axios({
                    headers: { Authorization: userToken },
                    method: "DELETE",
                    url: HttpConf.API_BASE + appPath,
                    data: appQuery,
                });
            }
            else if (appMethod == "GET") {
                response = yield axios({
                    headers: { Authorization: userToken },
                    method: appMethod,
                    url: HttpConf.API_BASE + appPath,
                    params: appQuery,
                });
            }
            else if (appMethod == "GETF") {
                response = yield axios({
                    method: "GET",
                    responseType: "blob",
                    url: HttpConf.API_BASE + appPath,
                    params: appQuery,
                });
            }
            httpResp.status = yield response.status;
            httpResp.codeNum = Object.prototype.hasOwnProperty.call(response.data, "codeNum")
                ? yield response.data.codeNum
                : 200;
            httpResp.errorList = Object.prototype.hasOwnProperty.call(httpResp.data, "errorList")
                ? yield response.data.errorList
                : [{ msg: "" }];
            httpResp.data = yield response.data;
            httpResp.body = Object.prototype.hasOwnProperty.call(httpResp.data, "list")
                ? response.data.list
                : response.data.data;
            return httpResp;
        }
        catch (err) {
            for (let errorNinewatt of err.response.data.errorList) {
                if (!errorNinewatt.isExhibit && errorNinewatt.field == "detail") {
                    let msg = "분석 중 오류가 발생했습니다.";
                    if (localStorage.getItem("langId") != "1")
                        msg = "An error occurred during analysis.";
                    errorNinewatt.msg = msg;
                }
            }
            httpResp.status = yield err.response.status;
            httpResp.codeNum = Object.prototype.hasOwnProperty.call(err.response.data, "codeNum")
                ? yield err.response.data.codeNum
                : 9999;
            httpResp.errorList = Object.prototype.hasOwnProperty.call(err.response.data, "errorList")
                ? yield err.response.data.errorList
                : [{ msg: "Undefined error!" }];
            httpResp.data = yield err.response.data;
            httpResp.body = yield err.response.data;
            return httpResp;
        }
        finally {
            return httpResp;
        }
    });
}
export function fileDownload2(fileName, fileUrl) {
    return __awaiter(this, void 0, void 0, function* () {
        //let response;
        if (CUTIL.isnull(fileUrl))
            return;
        try {
            axios({
                url: fileUrl,
                method: "GET",
                responseType: "blob",
            }).then((response) => {
                // 다운로드(서버에서 전달 받은 데이터) 받은 바이너리 데이터를 blob으로 변환합니다.
                const blob = new Blob([response.data]);
                // 특정 타입을 정의해야 경우에는 옵션을 사용해 MIME 유형을 정의 할 수 있습니다.
                // blob을 사용해 객체 URL을 생성합니다.
                const fileObjectUrl = window.URL.createObjectURL(blob);
                // blob 객체 URL을 설정할 링크를 만듭니다.
                const link = document.createElement("a");
                link.href = fileObjectUrl;
                link.style.display = "none";
                // 다운로드 파일 이름을 지정 할 수 있습니다.
                // 일반적으로 서버에서 전달해준 파일 이름은 응답 Header의 Content-Disposition에 설정됩니다.
                // 다운로드 파일의 이름은 직접 지정 할 수 있습니다.
                link.download = fileName;
                // 링크를 body에 추가하고 강제로 click 이벤트를 발생시켜 파일 다운로드를 실행시킵니다.
                document.body.appendChild(link);
                link.click();
                link.remove();
                // 다운로드가 끝난 리소스(객체 URL)를 해제합니다.
                window.URL.revokeObjectURL(fileObjectUrl);
            });
        }
        catch (err) { }
    });
}
export function fileDownload(fileName, fileUrl) {
    return __awaiter(this, void 0, void 0, function* () {
        //let response;
        if (CUTIL.isnull(fileUrl))
            return;
        try {
            axios({
                url: fileUrl,
                method: "GET",
                responseType: "blob",
            }).then((response) => {
                const disposition = response.headers["content-disposition"]; // for file name
                FILEUTILS.saveToFile_Chrome(fileName, response.data);
            });
        }
        catch (err) { }
    });
}
// File 다운로드
export function fileDownload_EhcReport(reportName, reportId, userToken, fileType) {
    return __awaiter(this, void 0, void 0, function* () {
        let data = null;
        data = yield PromiseHttp({
            httpMethod: "GET",
            appPath: `/report/${reportId}`,
            appQuery: {},
            userToken: userToken,
        });
        if (data) {
            if (data.codeNum == 200) {
                fileDownload(decodeURI(`${reportName}.${fileType != null && fileType == "WORD" ? "docx" : "pdf"}`), data.body.fileLink);
            }
            else {
            }
        }
    });
}
export function fileDownload_WithPdfViewer(reportName, reportId, userToken) {
    return __awaiter(this, void 0, void 0, function* () {
        if (CUTIL.isnull(reportId))
            return;
        let data = null;
        data = yield PromiseHttp({
            httpMethod: "GET",
            appPath: `/report/${reportId}`,
            appQuery: {},
            userToken: userToken,
        });
        if (data) {
            if (data.codeNum == 200) {
                window.open(`${CONST.URL_COMM_PDFVIEWER}?${CONST.STR_PARAM_DATA + CONST.STR_PARAM_PDFNM}=${reportName}_진단점검리포트.PDF&${CONST.STR_PARAM_DATA + CONST.STR_PARAM_PDFID}=${data.body.fileLink}`, "_blank", "noreferrer");
            }
        }
    });
}
/*
 */
export function API_reportView(serialNo) {
    return __awaiter(this, void 0, void 0, function* () {
        let ret = null;
        try {
            yield axios
                .post("https://eaiprod.ls-electric.com/service/rest", {
                request: {
                    header: {
                        IF_ID: "IF_SRD_EHEALTH_TRM_0001",
                        IF_GUUID: UNIQUE.genGUUID(),
                        IF_UUID: UNIQUE.genUUID(),
                        IF_DATETIME: Date.now(),
                    },
                    body: {
                        IF_TOTAL_CNT: "0",
                        IF_SPLIT_CNT: "0",
                        IF_SPLIT_SEQ: "0",
                        IF_REQ_DATA: { SERIAL: serialNo },
                    },
                },
            })
                .then((resp) => {
                if (resp.status == 200) {
                    ret = resp.data.response.body;
                }
            });
        }
        catch (err) { }
        return ret;
    });
}
export function resultCheck(isLoading, result) {
    var err_url = "";
    if (!isLoading) {
        if (result === null) {
            err_url = CONST.URL_SYSTEM_ERROR;
        }
        else if (result.codeNum === CONST.API_999) {
            err_url = CONST.URL_SYSTEM_ERROR;
        }
        else if (result.codeNum !== CONST.API_200) {
            err_url = CONST.URL_NOT_FOUND;
        }
    }
    return err_url;
}
export function jsonFetch(url, httpMethod, token, data, callBack) {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");
    var raw = JSON.stringify(data);
    var requestOptions = {
        method: httpMethod,
        headers: myHeaders,
        body: raw,
        redirect: "follow",
    };
    fetch(HttpConf.API_BASE + url, requestOptions)
        .then((response) => response.text())
        .then((result) => {
        const data = JSON.parse(result);
        if (data.msg == "success") {
            if (!CUTIL.isnull(callBack)) {
                callBack(data);
            }
        }
    })
        .catch((error) => console.log("error", error));
}
/**
 * POST 로 보내고 파일(바이너리)로 돌려받아 바로 저장한다.
 * 서버가 만든 문서를 저장하지 않고 즉시 내려주는 경우에 쓴다 (예 인버터 제안서 PPT).
 * 파일명은 응답 Content-Disposition 의 filename* (RFC 5987) 을 우선 쓰고, 없으면 fallbackName 을 쓴다.
 *
 * @param appPath      API 경로
 * @param body         요청 본문
 * @param userToken    인증 토큰
 * @param fallbackName Content-Disposition 이 없을 때 쓸 파일명
 * @returns 성공 여부 — 실패 시 에러 메시지를 함께 돌려준다
 */
export function postFileDownload(appPath, body, userToken, fallbackName) {
    var _a, _b, _c, _d, _e;
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield axios({
                headers: { Authorization: userToken, "Content-Type": "application/json" },
                method: "POST",
                url: HttpConf.API_BASE + appPath,
                data: body,
                responseType: "blob",
            });
            let fileName = fallbackName;
            const disposition = response.headers["content-disposition"];
            if (!CUTIL.isnull(disposition)) {
                const star = /filename\*=UTF-8''([^;]+)/i.exec(disposition);
                const plain = /filename="?([^";]+)"?/i.exec(disposition);
                if (star)
                    fileName = decodeURIComponent(star[1]);
                else if (plain)
                    fileName = decodeURIComponent(plain[1]);
            }
            FILEUTILS.saveToFile_Chrome(fileName, response.data);
            return { ok: true, msg: "" };
        }
        catch (err) {
            // 에러 응답도 blob 으로 오므로 텍스트로 되읽어 메시지를 꺼낸다
            let msg = "";
            try {
                const text = yield ((_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.text());
                const json = JSON.parse(text);
                msg = (_e = (_d = (_c = json === null || json === void 0 ? void 0 : json.errorList) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.msg) !== null && _e !== void 0 ? _e : "";
            }
            catch (e) { }
            return { ok: false, msg: msg };
        }
    });
}
